import classNames from "classnames";
import { SectionLayout } from "layouts";
import { Trans } from "react-i18next";
import styles from "./online-data-management.module.scss";

const OnlineDataManagement = () => {
  return (
    <SectionLayout
      separatorProps={{
        variant: "offset",
      }}
      heading={
        <Trans i18nKey="mhealth-studio.online-data-management.heading">
          A solution <strong>for online data management</strong>
        </Trans>
      }
    >
      <div className={styles.gridRoot}>
        <div className={styles.content}>
          <GridItem
            index={1}
            image="/assets/images/mhealth/online-data-management/ear-with-sound.svg"
            title="Remote audiology"
            alt="mHealth Studio enables the capibilites to view detailed test results from anywhere"
            text={
              <Trans i18nKey="mhealth-studio.online-data-management.info.remote-audiology">
                <strong>
                  Remote audiology <br />{" "}
                </strong>
                capabilities to view detailed test results from anywhere
              </Trans>
            }
          />
          <GridItem
            index={2}
            image="/assets/images/mhealth/online-data-management/people-around-globe.svg"
            title="Used by healthcare professionals globally"
            alt="mHealth Studio are used and trusted by healthcare professionals world wide"
            text={
              <Trans i18nKey="mhealth-studio.online-data-management.info.healthcare-professionals-globally">
                Used by <strong>healthcare professionals globally</strong>
              </Trans>
            }
          />
          <GridItem
            index={3}
            image="/assets/images/mhealth/online-data-management/screen-with-checklist.svg"
            title="Simple generation of comprehensive patient reports"
            alt="The patient report includes all necessary documentation and imagery to be included in medical documents"
            text={
              <Trans i18nKey="mhealth-studio.online-data-management.info.safe-and-secure">
                <strong>Safe and secure</strong> online data management platform
              </Trans>
            }
          />
          <GridItem
            index={4}
            image="/assets/images/mhealth/online-data-management/phone-and-laptop.svg"
            title="Safe and secure"
            alt="Safe and secure online data management platform"
            text={
              <Trans i18nKey="mhealth-studio.online-data-management.info.real-time-data-monitoring">
                <strong>Real-time data monitoring & seamless syncing </strong>
                between the mHealth Studio App and mHealth Studio Cloud
              </Trans>
            }
          />
          <GridItem
            index={5}
            image="/assets/images/mhealth/online-data-management/guy-with-checklist.svg"
            title=""
            alt=""
            text={
              <Trans i18nKey="mhealth-studio.online-data-management.info.referral-management">
                <strong>Referral management</strong> and tracking of patient
                journey
              </Trans>
            }
          />
          <GridItem
            index={6}
            image="/assets/images/mhealth/online-data-management/lady-portfolio.svg"
            title="Referral management"
            alt="mHealth Studio offers you secure access to referrals the generated from your clinical software"
            text={
              <Trans i18nKey="mhealth-studio.online-data-management.info.patient-reports">
                Simple generation of comprehensive{" "}
                <strong>patient reports</strong>
              </Trans>
            }
          />
        </div>
      </div>
    </SectionLayout>
  );
};

export default OnlineDataManagement;

interface GridItemProps {
  index: number;
  image: string;
  title: string;
  alt: string;
  text: React.ReactElement;
}

const GridItem: React.FC<GridItemProps> = ({
  image,
  text,
  index,
  title,
  alt,
}) => (
  <>
    <div
      className={classNames(
        styles.gridItem,
        styles[`gridItem${index}Image`],
        styles.gridItemImage
      )}
      style={{
        gridArea: `image-${index}`,
      }}
    >
      <img
        src={image}
        title={title}
        alt={alt}
        aria-hidden
        role="presentation"
      />
    </div>
    <div
      className={classNames(
        styles.gridItem,
        styles[`gridItem${index}Text`],
        styles.gridItemText
      )}
      style={{
        gridArea: `text-${index}`,
      }}
    >
      <div>{text}</div>
    </div>
  </>
);
